// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3B_Iv","label":"Radio_label__3pzFm","checkMark":"Radio_checkMark__6Aop-","disabled":"Radio_disabled__30Bjd"};